import React from 'react';
import ReactDOM from 'react-dom';
import { transitions, Provider as AlertProvider } from 'react-alert';
import AlertMUITemplate from "react-alert-template-mui";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createBrowserHistory } from 'history';

const options = {
  // you can also just use 'bottom center'
  timeout: 5000,
  offset: '40px',
  // you can also just use 'scale'
  transition: transitions.SCALE,
}

const history = createBrowserHistory();

const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
if (path) {
  history.replace(path);
}

ReactDOM.render(
  <React.StrictMode>
    <AlertProvider template={AlertMUITemplate} {...options}>
      <App />
    </AlertProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
